import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { Booking } from './Booking.js';

export enum Grade {
  FIRST = '1',
  SECOND = '2',
  THIRD = '3',
  FOURTH = '4',
  FIFTH = '5',
  SIXTH = '6',
  SEVENTH = '7',
  EIGHTH = '8',
  NINTH = '9',
  TENTH = '10',
  ELEVEN = '11',
  TWELVE = '12',
  THIRTEEN = '13',
}

/**
 * The ClassBooking is the booking for a specific class on a school. so it has the extra fields grade and classIdentifier
 * @class
 * @extends Booking
 */
@Entity()
export class ClassBooking extends Booking {
  static override _class = 'ClassBooking';

  constructor(doc: PartialEntityData<ClassBooking>) {
    super(doc);
  }

  /**
   * In which schoolyear the class booking is. The start- and enddate will prefill it but they can be changed manually.
   * Because of this we cannot compare things directly to determine unqiue class bookings per schoolyear per school-
   * This primarily used for the person import to check if a person already has a schoolyear booking for the same class. If so, we will not create a new one but update the existing one.
   */
  @Field(() => String)
  schoolyear: Maybe<string>;

  // This is a string as it could also be some courses like E, Q1, Q2, Q3 while the grade is just the year
  @Field(() => String)
  grade: Maybe<string>;

  // Identifier for the class like A, B, C, can be something like Mathe Tutor or something to also do courses
  @Field(() => String)
  classIdentifier: Maybe<string>;
}
